<template>
    <div class="m-userControl ml-3">
        <a-icon
            id="mobile-promos-icon"
            v-tooltip="'Promocje'"
            icon="Promotions"
            class="text-primary mr-2 pr-1 m-userControl__promos"
            @click.native="
                $router.history.current.name !== 'promo-list' &&
                    $router.push('/promo-list')
            "
        />
        <user-diagnostics v-if="!isLotteryUser" />
        <user-news />
        <user-navigation />
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#main-nav"
            aria-controls="main-nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span
                @click="$store.dispatch('toggleMobileMenu')"
                class="navbar-toggler-icon"
            ></span>
        </button>
        <button
            @click="tour.start()"
            class="btn btn-secondary m-userControl__tutorialButton"
            id="tutorial-btn"
        >
            Samouczek
        </button>
    </div>
</template>

<script>
import UserDiagnostics from '@/components/header/UserDiagnostics'
import UserNews from '@/components/header/UserNews'
import UserNavigation from '@/components/header/UserNavigation'
import { tour } from '@/walkthroughs/promoAccept'

export default {
    name: 'UserControl',
    components: {
        UserDiagnostics,
        UserNews,
        UserNavigation
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        }
    },
    data() {
        return { tour }
    }
}
</script>
